import TranslateIcon from '@mui/icons-material/Translate';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import type { BookLanguageRow } from '../../Settings/lists/singleTableListSupport';
import type { BookFormDraft } from './types';

type BookFormStepDescriptionsProps = {
  draft: BookFormDraft;
  enabledLanguages: BookLanguageRow[];
  canTranslateDescFromEn: boolean;
  descTranslating: boolean;
  descTranslateError: string | null;
  onDismissDescTranslateError: () => void;
  onTranslateDescFromEn: () => void;
  setDescriptionForLang: (langId: string, value: string) => void;
  stepNavigation: React.ReactNode;
};

export default function BookFormStepDescriptions({
  draft,
  enabledLanguages,
  canTranslateDescFromEn,
  descTranslating,
  descTranslateError,
  onDismissDescTranslateError,
  onTranslateDescFromEn,
  setDescriptionForLang,
  stepNavigation,
}: BookFormStepDescriptionsProps) {
  return (
    <Box>
      {enabledLanguages.length === 0 ? (
        <Alert severity="info">Эхний алхамд дор хаяж нэг хэл идэвхжүүлнэ үү.</Alert>
      ) : (
        <>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Номын танилцуулга (сонгосон хэл бүрээр, дээд тал нь 20 үгтэй).
          </Typography>
          <Box sx={{ mb: 2 }}>
            <Button
              type="button"
              variant="outlined"
              size="small"
              startIcon={descTranslating ? <CircularProgress size={16} color="inherit" /> : <TranslateIcon />}
              disabled={descTranslating || !canTranslateDescFromEn}
              onClick={() => void onTranslateDescFromEn()}
            >
              Англиас бусад хэл рүү орчуулах (тайлбар)
            </Button>
          </Box>
          {descTranslateError && (
            <Alert severity="error" onClose={onDismissDescTranslateError} sx={{ mb: 1 }}>
              {descTranslateError}
            </Alert>
          )}
          {enabledLanguages.map((lang) => (
            <TextField
              key={lang.id}
              label={`Тайлбар — ${lang.name} (${lang.id})`}
              value={draft.description_map[lang.id] ?? ''}
              onChange={(e) => setDescriptionForLang(lang.id, e.target.value)}
              fullWidth
              multiline
              minRows={3}
              margin="dense"
            />
          ))}
        </>
      )}
      {stepNavigation}
    </Box>
  );
}
